<template>
  <div class="page-container">
    <DemoForm/>
    <CallMe/>
  </div>
</template>

<script>
import DemoForm from '@/components/demo'
import CallMe from '@/components/callme/index'
export default {
  components: {
    DemoForm,
    CallMe,
  },
}
</script>

<style scoped>
.page-container {
  padding-top: 70px; /* 为固定导航栏预留空间 */
}
</style>
